import type {
  BffCatalogProduct,
  BffCatalogSubscription,
} from '@/core/models/bff-catalog';

/** Resolve a catalog row by stable article `code` (same across environments). */
export function findCatalogProductByCode(
  products: BffCatalogProduct[] | undefined,
  code: string,
): BffCatalogProduct | undefined {
  return products?.find(p => p.code === code);
}

/**
 * Match a subscription by BFF `id` or stable `code` (e.g. legacy STTU… trade ids).
 */
export function findCatalogSubscriptionByCatalogKey(
  subscriptions: BffCatalogSubscription[] | undefined,
  key: string,
): BffCatalogSubscription | undefined {
  return subscriptions?.find(s => s.id === key || s.code === key);
}
